var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2828_9504)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.793 13.6a4.573 4.573 0 00-4.287-6.173c-.539 0-1.074.097-1.58.286L12 8.82A3.247 3.247 0 0115.747 12c0 .165-.014.33-.04.493l1.086 1.107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 11.686C20.613 7.533 16.673 5.02 12.313 5.02a11.214 11.214 0 00-3.493.566l1.073 1.08a9.853 9.853 0 012.42-.313c3.754 0 7.167 2.093 9.2 5.62a11.832 11.832 0 01-2.913 3.4l.947.947a13.286 13.286 0 003.333-4l.173-.32-.193-.314zM3.246 3.854L6.22 6.827a13.013 13.013 0 00-4.46 4.86L1.586 12l.174.32c2.246 4.154 6.186 6.667 10.546 6.667 1.702 0 3.382-.385 4.914-1.127l3.333 3.334 1.167-1L4.386 2.86l-1.14.994zm6.5 6.5l4.434 4.433a3.206 3.206 0 01-1.667.48A3.247 3.247 0 019.266 12a3.207 3.207 0 01.48-1.646zm-.966-.967a4.567 4.567 0 006.366 6.367l1.067 1.066a9.942 9.942 0 01-3.907.8c-3.753 0-7.166-2.093-9.2-5.62a11.526 11.526 0 014.08-4.2L8.78 9.387z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2828_9504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.70c63b4adb02d956b64f1620334db7dc.svg";
export { ForwardRef as ReactComponent };